import React, { useEffect, useRef, useState } from "react";
import {
  Spin,
  Table,
  Switch,
  Row,
  InputNumber,
  Button,
  Card,
  Modal,
  Form,
  Select,
  Col,
  message
} from "antd";
import { useLocation, useNavigate, Link, useParams } from "react-router-dom";
import _ from "lodash";
import PageTitle from "components/PageTitle";
import { parseQueryParams, stringifyQueryParams } from "utils/url";
import api from "utils/api";

// request
import { updateMerchanatLimit, getMerchantCommision } from "requests/user";
import { type } from "@testing-library/user-event/dist/type";
const { Option } = Select;
const MerchantLimit = () => {
    const [form] = Form.useForm();
  const [titles, setTitles] = useState([
    { path: "", title: "Rate & Commission" },
  ]);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(
    process.env.REACT_APP_RECORDS_PER_PAGE
  );
  const [totalCount, setTotalCount] = useState(0);
  const [records, setRecords] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [merchantId, setMerchantId] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const searchRef = useRef(null);
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const segment = window.location.pathname.split("/");
  console.warn(segment[2]);

  const columns = [
    {
      title: "Min TA",
      dataIndex: "startamount",
      key: "startamount",
      render: (text, record) => {
        return (
          <InputNumber
            size="small"
            defaultValue={text}
            onChange={(value) => onUpdate(record._id, { startamount: value })}
          />
        );
      },
    },

    {
      title: "Max TA",
      dataIndex: "endamount",
      key: "endamount",
      render: (text, record) => {
        return (
          <InputNumber
            size="small"
            defaultValue={text}
            onChange={(value) => onUpdate(record._id, { endamount: value })}
          />
        );
      },
    },

    {
      title: "Type",
      key: "type",
      dataIndex: "type",
    },

    {
      title: "Category",
      key: "category",
      dataIndex: "category",
      render: (category) => category
      ?`${category.name || "N/A"} (${(category.category_name) || "N/A"})`:"N/A",
    },
   

{title: "Commission fee",
      dataIndex: "commission",
      key: "commission",
      render: (text, record) => {
        return (
          <InputNumber
            size="small"
            defaultValue={text}
            disabled={!record.commission_fee}
            onChange={(value) => onUpdate(record._id, { commission: value })}
          />
        );
      },
    },


    //  {title: " Distributor Commission fee",
    //   dataIndex: "Distributor Commission fee",
    //   key: "Distributor Commission fee",
    //   render: (text, record) => {
    //     return (
    //       <InputNumber
    //         size="small"
    //         defaultValue={text}
    //         onChange={(value) => onUpdate(record._id, { commission: value })}
    //       />
    //     );
    //   },
    // },

    {
      title: "Transaction fee (%)",
      dataIndex: "transationcommission",
      key: "transationcommission",
      render: (text, record) => {
        return (
          <InputNumber
            size="small"
            defaultValue={text}
             disabled={!record.transaction_fee}
            onChange={(value) =>
              onUpdate(record._id, { transationcommission: value })
            }
          />
        );
      },
    },
    {
      title: "Distributor fee (%)",
      dataIndex: "distributorcommission",
      key: "distributorcommission",
      render: (text, record) => {
        return (
          <InputNumber
            size="small"
            defaultValue={text}
              disabled={!record.distributor_fee}
            onChange={(value) =>
              onUpdate(record._id, { distributorcommission: value })
            }
          />
        );
      },
    },
  ];

  useEffect(() => {
    const query = parseQueryParams(location);
    getRecords(query);
  }, [location]);

  const getRecords = async (query) => {
    try {
      const segment = window.location.pathname.split("/");
      console.warn(segment[2]);
      const merchantIDClient = segment[2];

      setIsTableLoading(true);

      const formData = new FormData();
      formData.append("merchant_id", merchantIDClient);
      formData.append("commissiontype", "payout");

      const response = await api.post(
        "https://billpay.mtmpay.in/Admin/api/admin/merchant-commission-list",
        formData,
        {}
      );

      console.warn(response.data.data);
      setRecords(response.data.data);
      setCategoryData(response.data.category);
      setPage(response.page);
      setPerPage(response.per_page);
      setTotalCount(response.total_records);
    } catch (err) {
      console.log(err);
    } finally {
      setIsTableLoading(false);
    }
  };

  const getCategoryList = async () => {
    try {
      const response = await api.get("https://billpay.mtmpay.in/Admin/api/admin/all-subcategory-list");
      setCategoryData(response.data.data);
    } catch (err) {
      console.log("Error fetching category list:", err);
    }
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  const onSearch = (keyword) => {
    let query = parseQueryParams(location);
    query = {
      ...query,
      page: 1,
      keyword: keyword,
    };

    navigate({
      pathname: location.pathname,
      search: stringifyQueryParams(query),
    });
  };

  const [formData, setFormData] = useState({
    startamount: null,
    endamount: null,
    type: "flat",
    commission: null,
    category_id: null,
      transaction_fee: true,        
      distributor_fee: true,
      commission_fee: true,
      transationcommission: null, 
      distributorcommission: null 

  });

  const showModal = (merchantId) => {
    const segment = window.location.pathname.split("/");
    // console.warn(segment[2]);
    setMerchantId(segment[2]);
    setIsModalVisible(true);
      getCategoryList(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleInputChange = (field, value) => {

     if (field === "category_id") {
    const selectedCategory = categoryData.find((cat) => cat._id === value);

    if (selectedCategory) {
      setFormData((prev) => ({
        ...prev,
        category_id: value,
        transaction_fee: selectedCategory.transaction_fee,
        distributor_fee: selectedCategory.distributor_fee,
        commission_fee: selectedCategory.commission_fee, 
        transationcommission: selectedCategory.transaction_fee ? selectedCategory.transationcommission : 0,
      commission: selectedCategory.commission_fee ? selectedCategory.commission : 0,
      distributorcommission: selectedCategory.distributor_fee ? selectedCategory.distributorcommission : 0

      }));
    } else {
      // fallback in case category is not found
      setFormData((prev) => ({
        ...prev,
        category_id: value,
        transaction_fee: false,
        distributor_fee: false,
        commission_fee: false,
      }));
    }
  } else {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  }
  };

  const handleTypeChange = (value) => {
    handleInputChange("type", value);
  };

  // const handleAddLimit = async () => {
  //   
  //   const requestData = {
  //     merchant_id: merchantId,
  //     startamount: formData.startamount,
  //     endamount: formData.endamount,
  //     type: formData.type,
  //     distributorcommission: formData.distributorcommission,
  //     transationcommission: formData.transationcommission,
  //     category_id: formData.category_id,
  //     commissiontype: "payout",
  //   };

  //   try {


      
  //     const response = await api.post(
  //       "https://billpay.mtmpay.in/Admin/api/admin/merchant-commission-store",
  //       requestData
  //     );
  //     console.warn("API response:", response.data);
  //     getRecords();
  //     setIsModalVisible(false);
  //   } catch (error) {
  //     console.error("API error:", error);
  //     console.log("hello");
  //   }
  // };
   
const handleAddLimit = async () => {
    try {
      const values = await form.validateFields();             
      const requestData = {
        merchant_id: merchantId,
        ...values,
        commissiontype: "payout",
             transationcommission: values.transaction_fee ? values.transationcommission : 0,
      commission: values.commission_fee ? values.commission : 0,
      distributorcommission: values.distributor_fee ? values.distributorcommission : 0
      };
      const response = await api.post(
        "https://billpay.mtmpay.in/Admin/api/admin/merchant-commission-store",
        requestData
      );
 if(response.data.status == 1) {
        message.success(response.data.message);  
         
      }     
      if (response.data.status == 0) {
        message.error(response.data.message);

 
 }
   form.resetFields();
      getRecords();
      setIsModalVisible(false);
    } catch (error) {
      console.error("API error:", error);
    }
  };


  const onRefresh = () => {
    let query = parseQueryParams(location);
    query = {
      page: 1,
      keyword: "",
    };

    navigate({
      pathname: location.pathname,
      search: stringifyQueryParams(query),
    });

    if (searchRef.current?.input.value) {
      searchRef.current.handleReset();
    }
  };

  const onChangeTable = (pagination) => {
    console.log(pagination);

    let query = parseQueryParams(location);
    query = {
      ...query,
      page: pagination.current,
      per_page: pagination.pageSize,
    };

    navigate({
      pathname: location.pathname,
      search: stringifyQueryParams(query),
    });
  };

  const onUpdate = _.debounce(async (id, data) => {
    try {
      setIsTableLoading(true);
      await updateMerchanatLimit(id, data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsTableLoading(false);
    }
  }, 500);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
    },
  };



  const handleKeyDown = (e) => {
  const allowedKeys = [
    "Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab", "Enter", "Home", "End",
    "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."
  ];
  if (!allowedKeys.includes(e.key)) {
    e.preventDefault();
  }
};
  return (
    <div>
      <div className="overviewBorder">
        <Row justify="space-between" align="middle">
          <Card className="small_card">
            <PageTitle titles={titles} />
          </Card>
          <Card className="small_card">
            <Button type="primary" onClick={() => showModal()}>
              Add Limit
            </Button>
          </Card>
          <Card className="small_card">
            <Link to="/payin-payout-permission">
              <Button type="primary" size="large">
                <span style={{ marginRight: "7px", fontSize: "18px" }}>
                  &larr;
                </span>{" "}
                Back
              </Button>
            </Link>
          </Card>
        </Row>
      </div>
      <Spin spinning={isTableLoading}>
        <Table
          style={{ marginTop: "10px" }}
          dataSource={records}
          columns={columns}
          onChange={onChangeTable}
          rowKey={"id"}
          scroll={{
            x: true,
          }}
        />
      </Spin>
    <Modal
        title="Add Limit"
        visible={isModalVisible}
        form={form}
        onCancel={handleCancel}
        onOk={handleAddLimit}
      >
        <Form layout="vertical" form={form}>
          <Row gutter={[16, 16]}>
            <Col g={12} md={12} sm={24} xs={24}>
              <Form.Item
                label="Start Amount"
                name="startamount"
                rules={[
                  { required: true, message: "Start amount is required" }
                ]}
              >
                <InputNumber
                  value={formData.startamount}
                  onChange={(value) => handleInputChange("startamount", value)}
                  onKeyDown={handleKeyDown}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col g={12} md={12} sm={24} xs={24}>
              <Form.Item
                label="End Amount"
                name="endamount"
                rules={[{ required: true, message: "End amount is required" }]}
              >
                <InputNumber
                  value={formData.endamount}
                  onChange={(value) => handleInputChange("endamount", value)}
                  onKeyDown={handleKeyDown}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col g={12} md={12} sm={24} xs={24}>
              <Form.Item
                label="Type"
                name="type"
                style={{ width: "100%" }}
                rules={[{ required: true, message: "Type is required" }]}
              >
                <Select value={formData.type} onChange={handleTypeChange}>
                  <Option value="flat">Flat</Option>
                  <Option value="percent">Percent</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col g={12} md={12} sm={24} xs={24}>
              <Form.Item
                label="Category"
                name="category_id"
                rules={[{ required: true, message: "Category is required" }]}
              >
                <Select
                  placeholder="Select category"
                  onChange={(value) => handleInputChange("category_id", value)}
                  value={formData.category_id}
                  onKeyDown={handleKeyDown}
                >
                  {categoryData &&
                    categoryData.map((category) => (
                      <Option key={category._id} value={category._id}>
                        {category.name}({category.category_name})
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col g={12} md={12} sm={24} xs={24}>
              <Form.Item
                label="Transation Commission"
                name="transationcommission"
                // rules={[{ required: true, message: "Transaction commission is required" }]}
                onKeyDown={handleKeyDown}
              >  <p style={{display:"none"}}>{formData.transationcommission}</p>
                <InputNumber
                  value={formData.transationcommission}
                  disabled={!formData.transaction_fee}
                  onChange={(value) =>
                    handleInputChange("transationcommission", value)
                  }
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col g={12} md={12} sm={24} xs={24}>
              <Form.Item
                label="Distributer Commission"
                name="distributorcommission"
                //  rules={[{ required: true, message: "Distributor commission is required" }]}
              >
                <p style={{display:"none"}}>{formData.distributorcommission}</p>
                <InputNumber
                  value={formData.distributorcommission}
                  disabled={!formData.distributor_fee}
                  onChange={(value) =>
                    handleInputChange("distributorcommission", value)
                  }
                  onKeyDown={handleKeyDown}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col g={12} md={12} sm={24} xs={24}>
              <Form.Item
                label="commission"
                name="commission"
                // rules={[{ required: true, message: "Commission is required" }]}
              >  <p style={{display:"none"}}>{formData.commission}</p>
                <InputNumber
                  value={formData.commission}
                  disabled={!formData.commission_fee}
                  onChange={(value) => handleInputChange("commission", value)}
                  onKeyDown={handleKeyDown}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
export default MerchantLimit;
